<template>
  <b-card no-body>
    <b-overlay
      :show="loading"
      variant="white"
      spinner-variant="primary"
      rounded="sm"
    >
      <b-row
        class="p-2"
        align-v="center"
        align-h="between"
      >
        <b-col
          class="font-weight-bold d-flex align-items-center"
          cols="auto"
        >
          <span class="text-uppercase">productos y servicios ofertados</span>
        </b-col>
        <b-col cols="auto">
          <b-button
            variant="primary"
            class="text-nowrap rounded-sm px-2 mr-1"
            @click="creationModalVisible = !creationModalVisible"
          >
            Nuevo producto / servicio
          </b-button>
          <b-button
            v-if="showIpc"
            variant="outline-primary"
            class="text-nowrap rounded-sm px-2"
            @click="ipcModalVisible = true"
          >
            Aplicar IPC
          </b-button>
        </b-col>
      </b-row>
      <hr class="m-0">
      <template
        v-for="offerLines in groupedOfferLines"
      >
        <OfferLinesTable
          :key="offerLines.id"
          :offer-lines="offerLines"
        />
        <hr
          :key="offerLines.id + 'separator'"
          class="m-0"
        >
      </template>
      <b-row
        align-v="center"
        class="p-2"
      >
        <b-col
          class="text-dark-gray font-weight-bold"
          cols="auto"
        >
          <span class="text-uppercase">totales oferta</span>
        </b-col>
      </b-row>
      <b-row
        align-h="around"
        align-v="center"
        no-gutters
        class="py-2 px-1 bg-action-blue"
      >
        <b-col cols="auto">
          <span class="text-dark-gray font-very-small font-weight-bold">VENTA TOTAL: </span>
          <span class="text-gray-50">{{ offer? offer.total_sale : 0 | numberToLocalString }} €</span>
        </b-col>
        <b-col cols="auto">
          <span class="text-dark-gray font-very-small font-weight-bold">COSTE TOTAL: </span>
          <span class="text-gray-50">{{ offer ? offer.total_cost : 0 | numberToLocalString }} €</span>
        </b-col>
        <b-col cols="auto">
          <span class="text-dark-gray font-very-small font-weight-bold">BENEFICIOS: </span>
          <span class="text-gray-50"> {{ offer ? offer.benefit : 0 | numberToLocalString }} €</span>
        </b-col>
        <b-col cols="auto">
          <span class="text-dark-gray font-very-small font-weight-bold">MARGEN: </span>
          <span class="text-gray-50">{{ offer? offer.margin : 0 | numberToLocalString }} %</span>
        </b-col>
      </b-row>
    </b-overlay>
    <OfferLineCreationModal
      v-model="creationModalVisible"
      :offer="offer"
      @offer-line-created="handleOfferLineCreated"
    />
    <b-modal
      v-model="ipcModalVisible"
      title="Aplicar IPC a la oferta"
      centered
      hide-footer
    >
      <b-overlay
        :show="ipcLoading"
        variant="white"
        spinner-variant="primary"
        rounded="sm"
      >
        <b-form-group
          label="% de IPC"
          label-for="ipc-percent-input"
        >
          <b-form-input
            id="ipc-percent-input"
            :value="ipcPercent"
            type="text"
            inputmode="decimal"
            placeholder="% de IPC"
            @keydown="onIpcKeydown"
            @input="onIpcInput"
          />
        </b-form-group>
        <b-row align-h="center">
          <b-col cols="auto">
            <b-button
              variant="primary"
              class="text-nowrap rounded-sm px-2"
              :disabled="!ipcPercent"
              @click="applyIpc"
            >
              Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-overlay>
    </b-modal>
  </b-card>
</template>

<script>
import OfferLinesTable from '@/components/offers/table/OfferLinesTable.vue'
import OfferLineCreationModal from '@/components/offers/modal/OfferLineCreationModal.vue'
import OffersApi from '@/api/offers-api'
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'OfferLinesCard',
  components: { OfferLineCreationModal, OfferLinesTable },
  props: {
    showIpc: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      creationModalVisible: false,
      ipcModalVisible: false,
      ipcLoading: false,
      ipcPercent: null,
    }
  },
  computed: {
    ...mapGetters('offer', {
      offer: 'getOffer',
      groupedOfferLines: 'getGroupedOfferLines',
    }),
  },
  methods: {
    handleOfferLineCreated() {
      this.creationModalVisible = false
    },
    onIpcKeydown(event) {
      const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End']
      if (allowed.includes(event.key)) return
      if (event.key === ',' && !this.ipcPercent?.includes(',')) return
      if (event.key >= '0' && event.key <= '9') return
      event.preventDefault()
    },
    onIpcInput(value) {
      let sanitized = value.replace(/[^0-9,]/g, '')
      const parts = sanitized.split(',')
      if (parts.length > 2) {
        sanitized = parts[0] + ',' + parts.slice(1).join('')
      }
      if (parts.length === 2 && parts[1].length > 2) {
        sanitized = parts[0] + ',' + parts[1].substring(0, 2)
      }
      this.ipcPercent = sanitized
      this.$nextTick(() => {
        const input = document.getElementById('ipc-percent-input')
        if (input) input.value = sanitized
      })
    },
    async applyIpc() {
      this.ipcLoading = true
      try {
        await OffersApi.increaseIpc(this.offer.id, this.ipcPercent.replace(',', '.'))
        Vue.$toast('IPC aplicado con éxito.')
        this.ipcModalVisible = false
        this.ipcPercent = null
        this.$store.dispatch('offer/loadOffer', this.offer.id)
      } catch {
        Vue.$toast.error('Ocurrió un error al aplicar el IPC.')
      } finally {
        this.ipcLoading = false
      }
    },
  },
}
</script>

<style scoped>
</style>
